import React, { useState } from 'react'
import { Dialog, DialogActions, DialogContent } from '@mui/material'
import barcodeServices from '../barcodeServices';


function GenerateNewBatchComponent({setSelectedBatch,onSuccess}) {

    const [count,setCount] = useState("");
    const [dialogStatus, setDialogStatus] = useState(false);

    const generateBarcode = () =>{
        barcodeServices.generateBarcode({count:count}).then(res=>{
            setDialogStatus(false)
            onSuccess();
            setSelectedBatch(res.data.batchId)
            console.log(res.data);
        }).catch(error=>{
            console.log(error)
        })
    }


    return (
        <div className='row'>
            <div className='col-md-12'>
                <button className='btn btn-primary float-end' type="button" onClick={()=>setDialogStatus(true)} >Generate Barcode</button>
            </div>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                maxWidth="sm"
            >
                <DialogContent>
                    <div className='row mt-2'>
                        <div className='col-md-12'>
                            <form className="form-floating">
                                <input type="number" className="form-control" value={count} onChange={(e)=>setCount(e.target.value)} />
                                <label>Qty</label>
                            </form>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className="btn btn-outline-primary" onClick={generateBarcode} >Generate</button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default GenerateNewBatchComponent